module.exports = __webpack_public_path__ + "static/media/Poppins-Black-900.62a51d6c.ttf";